// extracted by mini-css-extract-plugin
module.exports = {"delta2_activity_page":"delta-2-portable-power-station-event_delta2_activity_page__246t0"};